import HomepageTemplate from "./homepage-template";
import LongTemplate from "./long-template/long-template";
import SegmentsTemplate from "./segments-template/segments-template";
import FixedLongLpTemplate from "./fixed-long-lp-template/fixed-long-lp-template";
import ArticleTemplate from "./article-template/article-template";
import DirectoryTemplate from "./directory-template/directory-template";
import DirectoryImagesTemplate from "./directory-images-template/directory-images-template";
import MultipleDirectoryImagesTemplate from "./multiple-directory-images-template/multiple-directory-images-template";
import OnePagerAssetTemplate from "./one-pager-asset-template/one-pager-asset-template";
import OnePagerWithImageTemplate from "./one-pager-with-image-template/one-pager-with-image-template";
import MobileOnePagerWithImageTemplate from "./one-pager-with-image-template/mobile-only/mobile-one-pager-with-image-template";
import OnePagerWithVideoTemplate from "./one-pager-with-video-template/one-pager-with-video-template";
import CompetitorTemplate from "./competitor-template/competitor-template";
import DynamicTemplate from "./dynamic-template/dynamic-template";
import MobileDynamicTemplate from "./dynamic-template/dynamic-template";
export default {
    HomepageTemplate,
    LongTemplate,
    SegmentsTemplate,
    FixedLongLpTemplate,
    ArticleTemplate,
    DirectoryTemplate,
    DirectoryImagesTemplate,
    MultipleDirectoryImagesTemplate,
    OnePagerAssetTemplate,
    OnePagerWithImageTemplate,
    MobileOnePagerWithImageTemplate,
    CompetitorTemplate,
    OnePagerWithVideoTemplate,
    DynamicTemplate,
    MobileDynamicTemplate,
    DevelopersCenterTemplate: DynamicTemplate,
    WelcomeNewJoinersTemplate: DynamicTemplate,
    RemoteWorkTemplate: DynamicTemplate
};
